module.exports = __webpack_public_path__ + "static/assets/c7ffd288176b935f835311512a224d4b.svg";